const PAGE_CACHE_TTL_MS = 30 * 1000;
const pageDataCache = new Map();

export const getCachedPageData = (key) => {
  const cached = pageDataCache.get(key);

  if (!cached) {
    return null;
  }

  if (Date.now() - cached.timestamp >= PAGE_CACHE_TTL_MS) {
    pageDataCache.delete(key);
    return null;
  }

  return cached.value;
};

export const setCachedPageData = (key, value) => {
  pageDataCache.set(key, {
    value,
    timestamp: Date.now(),
  });
};

export const invalidateCachedPageData = (key) => {
  pageDataCache.delete(key);
};
